import React, { useState } from 'react'
import Loader from 'components/Loader'
import { Box, Button, Typography, Grid } from '@mui/material'
import BrandedPageHeader from 'components/Layout/BrandedPageHeader'
import { fetchGetEmployerUsers } from 'src/redux/users'
import { useSelector, useDispatch } from 'react-redux'
import { AdminUsersTable } from 'components/Table/AdminUsersTable'
import EmployerUserDrawer from 'components/Drawers/EmployerUserDrawer'

const Users = () => {
  const dispatch = useDispatch()
  const { loading, users } = useSelector(state => state.users)
  const [isEditDrawerOpen, setEditDrawerOpen] = useState(false)
  const [selectedEmployerUser, setSelectedEmployerUser] = useState(null)

  const handleOpenEditDrawer = employerUser => {
    setSelectedEmployerUser(employerUser)
    setEditDrawerOpen(true)
  }

  const handleCloseEditDrawer = () => {
    setSelectedEmployerUser(null)
    setEditDrawerOpen(false)
  }

  const usersData = users.map(user => ({
    id: user.user.id,
    email: user.user.email,
    firstName: user.user.firstName,
    lastName: user.user.lastName,
    isEmployerAdmin: user.isEmployerAdmin === true ? 'Yes' : 'No',
    employer: user.employer.name,
    actions: (
      <Button variant='outlined' onClick={() => handleOpenEditDrawer(user)}>
        Edit
      </Button>
    ),
  }))
  React.useEffect(() => {
    dispatch(fetchGetEmployerUsers())
  }, [dispatch])

  return (
    <>
      <BrandedPageHeader>
        <Grid container spacing={0} sx={{ px: 0 }}>
          <Grid item xs={12} md={8} sx={{ pl: 0 }}>
            <Typography variant='h5' sx={{
              color: 'white',
              fontWeight: 'bold',
              mb: 1,
              pl: 0
            }}>
              Employer Users
            </Typography>
            <Typography variant='caption' sx={{
              color: 'rgba(255,255,255,0.7)',
              display: 'block',
              mb: { xs: 2, md: 0 },
              whiteSpace: 'normal',
              wordBreak: 'normal',
              pl: 0
            }}>
              Manage user accounts and permissions.
            </Typography>
          </Grid>
        </Grid>
      </BrandedPageHeader>
      <Box sx={{ mt: 4 }}>
        {loading ? <Loader /> : <AdminUsersTable data={usersData} />}
      </Box>
      <EmployerUserDrawer
        open={isEditDrawerOpen}
        onClose={handleCloseEditDrawer}
        initialValues={selectedEmployerUser}
        type='edit'
      />
    </>
  )
}
export default Users
